var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningAlerts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5095_66071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 3.7471C8.33407 4.48915 8.11448 5.21469 7.70251 5.83188C7.29055 6.44907 6.70474 6.93017 6.01923 7.21427C5.33372 7.49837 4.57933 7.57271 3.85155 7.42787C3.12377 7.28303 2.45532 6.92553 1.93082 6.40062C1.40631 5.87571 1.04933 5.20698 0.905058 4.47909C0.760784 3.7512 0.835707 2.99687 1.12034 2.31158C1.40498 1.62629 1.88652 1.04085 2.50403 0.629369C3.12155 0.217885 3.84726 -0.00114485 4.58931 4.50027e-06C5.58259 0.000774491 6.53494 0.395898 7.23703 1.09853C7.93911 1.80116 8.3335 2.75381 8.3335 3.7471Z",
    fill: "#E16E5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91683 3.40257L12.7657 11.7802H3.06797L7.91683 3.40257ZM7.91683 0.833252L4.37516 6.95068L0.833496 13.0681H15.0002L7.91683 0.833252ZM8.56077 9.8484H7.27289V11.1363H8.56077V9.8484ZM8.56077 5.98477H7.27289V8.56052H8.56077V5.98477Z",
    fill: "#001698"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5095_66071"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAlerts);
export default __webpack_public_path__ + "static/media/warning_alerts.3884e97166bd5cd2050cdc320f4958d5.svg";
export { ForwardRef as ReactComponent };